<template>
  <FormsCard>
    <router-link to="/auth" class="auth-back-link">
        <font-awesome-icon icon="fa-arrow-left"/>
        {{ $t('PasswordResetComponent.backToLogin') }}
    </router-link>
    <img class="block mx-auto mb-6 w-32 sm:w-40 h-auto" src="@/assets/omind_logo.png" alt="test">
    <h2 class="text-center pb-5 text-xl sm:text-2xl">
        {{ $t('PasswordResetComponent.forgotPassword') }}</h2>
    <p class="text-center px-2 text-base sm:text-lg my-8 sm:my-10">
        {{ $t('PasswordResetComponent.resetInstructions') }}</p>
      <Form :validateOnValueUpdate="false" :resolver="resolver" :validateOnBlur="true"
        @submit="requestPasswordReset" class="flex flex-col gap-4 w-full md:shrink-0">
          <FormField v-slot="$field" as="section" name="email"
              initialValue="" class="flex flex-col gap-1 ">
              <InputText type="text" size="large" :invalid="$field?.invalid"
                  :placeholder="$t('PasswordResetComponent.placeholders.forgotPassword')"/>
              <Message v-if="$field?.invalid" severity="error" size="small"
                  variant="simple">{{ $field.error?.message }}</Message>
          </FormField>
          <div class="flex flex-row">
              <LanguageComponent class="float-left mt-1 absolute"/>
          </div>
          <Button type="submit" :disabled="isSubmitting"
              class="btn-primary-accent mt-8 sm:mt-12 w-full sm:w-auto px-6 py-2.5 sm:px-12 sm:py-3 text-lg sm:text-2xl mx-auto block text-center" unstyled>
              {{ $t('PasswordResetComponent.resetPassword') }}
          </Button>
      </Form>
  </FormsCard>
</template>
<script>
import LanguageComponent from '@/components/global/LanguageComponent.vue';
import FormsCard from '../global/slots/FormsCard.vue';
import Button from 'primevue/button';
import { Form, FormField } from '@primevue/forms';
import { zodResolver } from '@primevue/forms/resolvers/zod';
import { z } from 'zod';
import InputText from 'primevue/inputtext';
import Message from 'primevue/message';

export default {
  name: 'PasswordResetComponent',
  components: {
    FormsCard,
    Button,
    LanguageComponent,
    Form,
    FormField,
    InputText,
    Message,
  },
  data() {
    return {
      isSubmitting: false,
      resolver: zodResolver(
        z.object({
          email: z.string().email({ message: 'Invalid email address.' }),
        }),
      ),
    };
  },
  methods: {
    async requestPasswordReset(values) {
      if (values.valid) {
        try {
          this.isSubmitting = true;
          await this.$store.dispatch('requestPasswordReset', { email: values.values.email });
          this.isSubmitting = false;
          this.$router.push('/auth/password-reset-success');
        } catch (error) {
          this.isSubmitting = false;
          const errorMessage = error.response.data.message;
          const errorCode = error.response.data.code;
          let toastErrorMessage;
          switch (errorCode) {
            case 40004:
              toastErrorMessage = this.$t(
                'PasswordResetComponent.toast.userNotFound',
                { param_name: 'E-Mail', param_email: values.values.email },
              );
              break;
            case 40012:
              toastErrorMessage = this.$t(
                'PasswordResetComponent.toast.invalidResetPasswordInformation',
              );
              break;
            default:
              toastErrorMessage = errorMessage;
          }
          this.isSubmitting = false;
          // Todo handle errors
          this.$toast.add({
            severity: 'error',
            summary: toastErrorMessage,
            detail: '',
            life: 3000,
          });
        }
      }
    },
  },
  unmounted() {
    this.$store.commit('setPasswordResetRequested', false);
  },
};
</script>
